export default __webpack_public_path__ + "static/media/notifications_icon.5cc4b85f.svg";